import { MouseEvent, useCallback } from 'react';

import { CloseButton, CloseButtonProps, Skeleton, useBreakpointValue } from '@chakra-ui/react';

import { IconsLinear } from '@nocowanie/icons/linear';

import { commonUiStateSlice, useAppSelector } from '@app/app-state';
import { useMapBackNavigation } from '@app/hooks/useMapBackNavigation';

export const MapCloseButton = ({
    isMapLoaded = true,
    ...rest
}: CloseButtonProps & { isMapLoaded?: boolean }) => {
    const isMobileBrowser = useAppSelector(commonUiStateSlice.selectors.selectIsMobileVersion);
    const isMobileRes = useBreakpointValue(
        {
            base: true,
            md: false,
        },
        {
            fallback: isMobileBrowser ? 'base' : 'lg',
        },
    );

    const { navigateToListing } = useMapBackNavigation();

    const redirectToListingPage = useCallback(
        (event: MouseEvent) => {
            navigateToListing();
        },
        [navigateToListing],
    );

    const buttonDesktopStyles = {
        bg: 'white',
        h: 10,
        w: 10,
        boxShadow: '2xl',
        _hover: {
            bg: 'gray.200',
        },
    };

    return (
        <Skeleton asChild loading={!isMapLoaded}>
            <CloseButton
                p={0}
                borderRadius={'full'}
                css={!isMobileRes && buttonDesktopStyles}
                onClick={redirectToListingPage}
                color={'gray.900'}
                {...rest}
            >
                {isMobileRes ? (
                    <IconsLinear.ArrowLeft size={'xl'} fontSize={'2xl'} />
                ) : (
                    <IconsLinear.Close size={'xl'} fontSize={'2xl'} />
                )}
            </CloseButton>
        </Skeleton>
    );
};
